export const GET_CURRENT_STRUCTURE = 'GET_CURRENT_STRUCTURE'
